/* Produkt-Tabs in die Bildspalte holen - Fahrrad Rachow
 *
 * Auf dem Desktop steht unter den Produktbildern viel leerer Raum (bei einem
 * typischen Rad rund 490px), weil die rechte Infospalte deutlich höher ist.
 * Die Tabs "Produktdetails / Eigenschaften" liegen darunter als eigener
 * Abschnitt über die volle Breite. Dieses Skript verschiebt sie in den freien
 * Raum. Gemessene Ersparnis auf einer Produktseite: 357px Seitenhöhe.
 *
 * Warum per JavaScript und nicht im Liquid:
 * Die Tabs sind ein eigenständiger Abschnitt mit eigenen Einstellungen (Tab-
 * Inhalte, Icons, Popup-Texte), die im Theme-Editor gepflegt werden. Ein
 * Abschnitt kann in Liquid nicht innerhalb eines anderen Abschnitts gerendert
 * werden. Die Tabs stattdessen in main-product.liquid einzubauen würde
 * bedeuten, sie als Blöcke nachzubauen und alle Inhalte zu migrieren - die
 * Pflege im Theme-Editor ginge dabei verloren. Deshalb bleibt der Abschnitt
 * unangetastet und wird nur umgehängt.
 *
 * WICHTIG - warum in .product__column-sticky hinein und nicht daneben:
 * Die Bildspalte ist position:sticky. Hängt man die Tabs als Geschwister
 * darunter, laufen die mitscrollenden Bilder über sie hinweg (gemessen: 499px
 * Überlappung). Innerhalb des Sticky-Blocks bilden Bilder und Tabs eine
 * Einheit und das passiert nicht.
 */
(() => {
  'use strict';

  /* Ab dieser Breite stehen Bild- und Infospalte nebeneinander und die
     Bildspalte ist sticky. Darunter wird nichts verschoben. */
  const DESKTOP = '(min-width: 990px)';

  const STYLES = `
    .tabs-in-column .custom-tabs-section-bg {
      margin: 22px 0 0;
      padding: 24px 0;
      border-radius: 8px;
    }
    .tabs-in-column .custom-tabs-wrapper {
      max-width: none;
      margin: 0;
      padding: 0 22px;
    }
  `;

  document.addEventListener('DOMContentLoaded', () => {
    const section = Array.from(document.querySelectorAll('.shopify-section')).find((el) =>
      el.id.indexOf('custom_product_tabs') !== -1
    );
    const target = document.querySelector('.product__column-sticky');

    /* Ohne Sticky-Block nicht verschieben - siehe Überlappung oben. */
    if (!section || !target) return;

    const style = document.createElement('style');
    style.textContent = STYLES;
    document.head.appendChild(style);

    /* Ursprungsplatz merken, damit auf schmalen Fenstern sauber zurückgehängt
       werden kann. */
    const home = { parent: section.parentElement, next: section.nextElementSibling };
    const mq = window.matchMedia(DESKTOP);

    function place() {
      if (mq.matches) {
        if (section.parentElement !== target) {
          target.appendChild(section);
          section.classList.add('tabs-in-column');
        }
      } else if (section.parentElement !== home.parent) {
        home.parent.insertBefore(section, home.next);
        section.classList.remove('tabs-in-column');
      }
    }

    place();

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', place);
    } else {
      mq.addListener(place);
    }
  });
})();

/* Beim Umschalten/Aufklappen der Tabs an den Anfang des Inhalts springen (seit 2026-10-02).
 * Ohne das landet man z. B. bei "Eigenschaften" mitten in der Tabelle:
 * - Desktop: Die Tabs sitzen in der mitlaufenden Bildspalte. Wird der Inhalt länger,
 *   springt die Spalte an ihren normalen Platz zurück und der Tab-Anfang liegt über dem Fenster.
 * - Handy: Der offene Reiter darüber klappt zu und schiebt alles nach oben.
 * Läuft nach den Klick-Handlern des Abschnitts (Bubble-Phase am document). */
(() => {
  'use strict';

  function offsetTop() {
    const header = document.querySelector('.section-header');
    const pos = header ? getComputedStyle(header).position : '';
    return (pos === 'sticky' || pos === 'fixed' ? header.offsetHeight : 0) + 16;
  }

  function keepInView(el) {
    if (!el) return;
    const offset = offsetTop();
    const top = el.getBoundingClientRect().top;
    if (top < offset || top > window.innerHeight - 120) {
      window.scrollTo({ top: Math.max(0, window.scrollY + top - offset), behavior: 'instant' });
    }
  }

  /* Handy: Der zuklappende Reiter würde 0,3 s animieren - so lange stünde die Position
     des neuen Reiters nicht fest. Deshalb klappt er ohne Animation zu. */
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest && e.target.closest('.custom-tabs-wrapper .accordion-toggle');
    if (!toggle) return;
    const own = toggle.closest('.tab-item');
    toggle.closest('.custom-tabs-wrapper').querySelectorAll('.tab-item.mobile-active').forEach((item) => {
      if (item === own) return;
      const body = item.querySelector('.tab-body');
      if (!body) return;
      body.style.transition = 'none';
      requestAnimationFrame(() => requestAnimationFrame(() => { body.style.transition = ''; }));
    });
  }, true);

  document.addEventListener('click', (e) => {
    if (!e.target.closest) return;
    const tabBtn = e.target.closest('.custom-tabs-wrapper .tab-button');
    if (tabBtn) {
      keepInView(tabBtn.closest('.tabs-nav') || tabBtn);
      return;
    }
    const toggle = e.target.closest('.custom-tabs-wrapper .accordion-toggle');
    if (toggle && toggle.classList.contains('open')) keepInView(toggle);
  });
})();
